import axios from 'axios';

const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api',
};

class KYCService {
  // Get KYC access token for SumSub integration
  async getKYCAccessToken() {
    try {
      // Using JWT token from login (access_token)
      const token = localStorage.getItem('access_token') || localStorage.getItem('token');
      const response = await axios.post(`${API_CONFIG.BASE_URL}/v1/kyc_get_access_token/`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,  // JWT uses Bearer, not Token
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Check user's KYC verification status
  async checkKYCStatus() {
    try {
      const token = localStorage.getItem('access_token') || localStorage.getItem('token');
      const response = await axios.post(`${API_CONFIG.BASE_URL}/v1/check_kyc/`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`,  // JWT uses Bearer
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Get KYC requirements for specific amount
  async getKYCRequirements(amount) {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(`${API_CONFIG.BASE_URL}/v1/kyc_requirements/`, {
        amount: amount
      }, {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }

  // Get KYC verification URL
  getKYCVerificationURL(token, userId) {
    // SumSub uses idensic for the verification UI (same for sandbox and production)
    // Sandbox vs production is determined by credentials (sbx: prefix in token)
    return `https://api.sumsub.com/idensic/#/token/${token}`;
  }

  // Check if KYC is enabled
  async isKYCEnabled() {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/v1/kyc_enabled/`);
      return response.data.enabled;
    } catch (error) {
      console.error('Error checking KYC enabled status:', error);
      return false;
    }
  }
}

const kycService = new KYCService();
export default kycService;
